import React, { useState } from 'react';
import styles from './MfAddComposition.module.css';
import MfSelectComp from './MfSelectComp';
import MfCreateNewComp from './MfCreateNewComp';
import { useMfImport } from 'features/compositions/context/MfImportContext';
import MfZateceno, { zaImena } from './MfZateceno';

const MfAddComposition = () => {
    const {
        setExist, selectedComposition, setSelectedComposition, allCompositionsList, tables, derivedName,
        existing,
    } = useMfImport();

    // Više celina u jednom prolazu → „u postojeću kompoziciju" nema smisla:
    // kompozicija je više, a imena im dolaze iz izvora. Izbor se zato ne
    // ponuđa, umesto da se ponudi i onda odbije.
    const many = (tables?.length ?? 0) > 1;

    // Na PRAZNOJ bazi podrazumevano ide „Create new composition".
    //
    // Ranije je uvek bio prvi jezičak — „Use existing" — koji na bazi bez
    // kompozicija prikazuje prazan spisak. To izgleda kao ćorsokak: korisnik
    // zaključi da uvoz nije moguć dok ručno ne napravi prvu kompoziciju, a
    // zapravo je drugi jezičak upravo za to.
    const hasAny = (allCompositionsList?.size ?? 0) > 0 && !many;
    const [tab, setTab] = useState(hasAny ? 1 : 2);

    // Kad nema ni jedne kompozicije, `exist` mora biti false od početka —
    // inače bi se prvi upis poslao kao „u postojeću", koje nema.
    React.useEffect(() => {
        if (!hasAny) setExist(false);
    }, [hasAny, setExist]);

    // Predlog imena iz izvora (`prescriptions` za MySQL tabelu `prescriptions`)
    // pripada isključivo jezičku „Create new composition" — na prethodnom isto
    // polje znači izabranu POSTOJEĆU kompoziciju.
    //
    // Zavisnosti su namerno samo `tab` i `derivedName`, bez `selectedComposition`:
    // predlog se postavlja kad se jezičak otvori, a ne posle svakog brisanja
    // polja — inače korisnik ne bi mogao da ga obriše da bi uneo svoje ime.
    React.useEffect(() => {
        if (tab === 2 && derivedName && !selectedComposition) setSelectedComposition(derivedName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab, derivedName]);

    const zatecenoSada = zaImena(existing, many ? tables.map((t) => t.name) : [selectedComposition]);

    const izaberiPostojecu = () => {
        setTab(1);
        setExist(true);
        setSelectedComposition('');
    }

    const createNew = () => {
        setTab(2);
        setExist(false);
        setSelectedComposition('');
    }
    return (
        <div className={styles.mf_add_composition}>
            {!many && (
                <div className={styles.select_tab}>
                    <button className={tab === 1 ? styles.active : ''} onClick={() => izaberiPostojecu()}>Use existing composition</button>
                    <button className={tab === 2 ? styles.active : ''} onClick={() => createNew()}>Create new composition</button>
                </div>
            )}
            {tab === 1 && <MfSelectComp />}
            {tab === 2 && <MfCreateNewComp />}
            <MfZateceno stavke={zatecenoSada} />
        </div>
    )
}

export default MfAddComposition;